module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/extend.js
// module id = 397
// module chunks = 6